$('body').on('click', '.variant--color--option span', function () {
  
  var $this = $(this);
  var coloroptionVal = $this.attr('data-value');
  var $li = $this.closest('li');
  var $options = $li.find('select.variant--option--value.hidden option');
   $this.siblings().removeClass('selected');
    $this.addClass('selected');
$li.find(`[class^="varaint--colors-"] span[data-value="${coloroptionVal}"]`).trigger('click');

  $options.each(function () {
    var $option = $(this);
    var loopselectVal = $option.text().trim();

    if (coloroptionVal === loopselectVal) {
     
      var selectboxId = $option.attr('data-attr');
      var productAvailability = parseInt($option.attr('data-available'), 10);
      var variantImage = $option.attr('data-image');

      // Update product image
      if (variantImage) {
        $li.find('.card__media img').attr('src', variantImage);
        $li.find('.card__media img').attr('srcset', variantImage);
      }

      // Update hidden variant ID input
      $li.find('.add-to--cart-button input.product-variant-id').val(selectboxId);

      // Handle add-to-cart button
      var $addToCartBtn = $li.find('.add-to--cart-button button');
      var soldMessage = $li.find('.add-to--cart-button').attr('data-sold-message');
      var defaultText = $addToCartBtn.attr('data-default-text') || 'Add to Cart';

      if (productAvailability < 1) {
      
      $this.addClass('out-of-stock');
        $addToCartBtn.text(soldMessage).attr('disabled', true);
      } else { 
        $this.removeClass('out-of-stock');
        $addToCartBtn.text(defaultText).attr('disabled', false);
      }
       $(this).parents('li').find('.buy-now--button .product-form__submit').trigger('click');
    }
  });
 
});

 
// quick view click 
$('body').on('click', '.card-product-quick-view--wrapper', function () {
  $(this).find('.quick-view-variants-wrapper').removeClass('hidden').addClass('visible');
});






// quick view options click



    
  $(document).on('click', '.option-values', function() {

    $(this).siblings().removeClass('selected');    
    $(this).addClass('selected');
    var parentLi = $(this).closest('li');
    
const allVariants = parentLi.find('.variant---option--has-not-last-color'); 
const lastVariant = allVariants.last(); 

const $lastSpan = lastVariant.find('span');

   setTimeout(function () {
  $('.card-product--loader').hide();   
      }, 500); 
 
updateStockAvailability(parentLi);


     if ($(this).is($lastSpan)) {
   
    $(this).parents('li').find('.card-product--loader').show();
    requestAnimationFrame(() => {
  $(this).parents('li').find('.buy-now--button .product-form__submit').trigger('click');
    });
  }
});

function updateStockAvailability(parentLi) {
  
    var selectedColor = parentLi.find('.variant-option--1 span.option-values.option-button.selected').data('value') || null;
    var selectedSize = parentLi.find('.variant-option--2 span.option-values.option-button.selected').data('value') || null;
    var selectedMaterial = parentLi.find('.variant-option--3 span.option-values.option-button.selected').data('value') || null;

    parentLi.find('.option-values').removeClass('out-of-stock');

    var availableVariants = {};

    parentLi.find('select.variant--option--value.hidden option').each(function () {
        var variantName = $(this).attr('data-title') || "";
        var variantQty = parseInt($(this).attr('data-available')) || 0;
     
        var variantId = $(this).attr('data-attr') || "";
       
        var variantImage = $(this).attr('data-image') || "";
        var variantParts = variantName.split('-').map(part => part.trim()).filter(Boolean);
        var key = variantParts.join('-');

        availableVariants[key] = {
            inStock: variantQty > 0,
            variantId: variantId,
            variantQty: variantQty,
            variantImage: variantImage
        };
    });

    function createKey(...values) {
        return values.filter(Boolean).join('-');
    }

    var selectedVariantKey = createKey(selectedColor, selectedSize, selectedMaterial);
  //console.log(selectedVariantKey)
   var selectedVariant = availableVariants[selectedVariantKey];
  
     if (selectedVariant && selectedVariant.variantId) {
  parentLi.find('.buy-now--button input.product-variant-id').val(selectedVariant.variantId);
}

    if (!$('.product-form__error-message-wrapper').hasClass('hidden')) {
     parentLi.find('.buy-now--button').removeClass('hidden').addClass('visible');
     parentLi.find('.product-form__buttons').addClass('hidden');
      }else{
            parentLi.find('.buy-now--button').addClass('hidden').removeClass('visible');
           parentLi.find('.product-form__buttons').removeClass('hidden');  
      }
       if (selectedVariant && selectedVariant.variantImage) {
  parentLi.find('.card__media img').attr('srcset', selectedVariant.variantImage);
  parentLi.find('.card__media img').attr('src', selectedVariant.variantImage);
}
    // **Fix out-of-stock detection**
    function checkStockAvailability(optionClass, selectedValues) {
        parentLi.find(optionClass + ' .option-values').each(function () {
            var value = $(this).data('value');
         
            var key = createKey(...selectedValues.map((v, i) => (i === selectedValues.indexOf(null) ? value : v)));
            if (!availableVariants[key] || availableVariants[key].variantQty <= 0) {
                $(this).addClass('out-of-stock');
            }
        });
    }

    checkStockAvailability('.variant-option--1', [null, selectedSize, selectedMaterial]);
    checkStockAvailability('.variant-option--2', [selectedColor, null, selectedMaterial]);
    checkStockAvailability('.variant-option--3', [selectedColor, selectedSize, null]);

}


// close icon click 
$('body').on('click', '.quick-view-variants-wrapper .icon-close', function () {
  const wrapper = $(this).closest('.quick-view-variants-wrapper');
 if (wrapper.hasClass('visible')) {
     setTimeout(function () {
      wrapper.removeClass('visible').addClass('hidden');
     }, 100); 
  } else {
   
  }
});

